// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Uly","col":"styles_col__3S0Su","actions":"styles_actions__3pp1_","conflict":"styles_conflict__3e0JE"};